export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">关于土豪漫画网</h2>
            <p className="text-sm text-foreground-500">你身边的漫画分类阅读伙伴</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
            <div className="lg:col-span-2">
              <div className="relative">
                <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20toned%20cozy%20reading%20scene%20with%20manga%20books%20and%20comic%20pages%20scattered%20on%20a%20wooden%20table%2C%20soft%20natural%20lighting%2C%20artistic%20manga%20illustration%20style%20with%20warm%20cream%20and%20coral%20accents%2C%20editorial%20photography%2C%20clean%20aesthetic%2C%20inviting%20atmosphere&width=600&height=450&seq=about-manga-illustration&orientation=landscape"
                    alt="土豪漫画网 - 关于我们"
                    title="土豪漫画网 - 漫画分类阅读平台"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>

            <div className="lg:col-span-3">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                <strong>土豪漫画网</strong>诞生于对漫画的无限热爱。我们深知每一位漫画爱好者寻找心仪作品的渴望，
                因此打造了这个集<strong>韩漫推荐</strong>、<strong>日漫大全</strong>与<strong>国漫排行榜</strong>于一体的综合漫画分类平台。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                我们坚持每日同步更新最新章节，确保你追更不断档。从热血战斗到甜蜜恋爱，从悬疑推理到奇幻冒险，
                覆盖全部分类漫画的精品内容，让每一位读者都能在这里找到属于自己的阅读天地。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                无论你是韩漫的忠实粉丝，还是日漫的骨灰级爱好者，亦或是正在崛起的国漫支持者，
                土豪漫画网都以最全的<strong>漫画分类</strong>和最快的更新速度，成为你值得信赖的漫画阅读伙伴。
              </p>

              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2 text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-lg"></i>
                  <span className="text-sm">12000+ 部漫画</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-lg"></i>
                  <span className="text-sm">每日同步更新</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-lg"></i>
                  <span className="text-sm">精准漫画分类</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}